import { getUserValueFromField } from "../../helpers/cosmos-field-value-extractor";
import { createProfileLink } from "../../helpers/cosmos-profile-link";

export const mapUser = (user, cosmosData) => {
  const { fields, titleFieldId, footerFieldId, isCosmosInstalled } = cosmosData;
  const rawFields = fields.map(({ fieldProps }) => fieldProps);

  return {
    accountId: user.accountId,
    name: user.publicName,
    avatarUrl: user.loading
      ? "https://superstorefinder.net/support/wp-content/uploads/2018/01/grey_style.gif"
      : `${window.AP._hostOrigin}${user.profilePicture?.path}`,
    url: isCosmosInstalled
      ? createProfileLink(user.accountId)
      : `${window.AP._hostOrigin}/wiki/people/${user.accountId}`,
    title: isCosmosInstalled
      ? getUserValueFromField(user.values || {}, rawFields, titleFieldId)
      : "",
    footer: isCosmosInstalled
      ? getUserValueFromField(user.values || {}, rawFields, footerFieldId)
      : "",
  };
};
